import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { updateFieldsFromRecentSearch } from '../../../adapters/book-widget-fields-recent-search-update/book-widget-fields-recent-search-update.adapter';
import * as fromBookWidgetActions from '../../actions/book-widget.actions';
import { getBookWidgetAem } from '../../selectors/aem.selectors';
import {
  getBookWidgetFields,
  getBookWidgetFieldsMasterConfig
} from '../../selectors/book-widget.selectors';
import { getCatalogApiFieldsValue } from '../../selectors/catalog-api.selectors';
import { getRetrieveSearchDataList } from '../../selectors/retrieve-search.selectors';

@Injectable({
  providedIn: 'root'
})
export class BookWidgetRecentSearchSelectionEffect {
  recentSearchItemSelected$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType(fromBookWidgetActions.RecentSearchItemSelected),
        concatLatestFrom(() => [
          this.store.select(getRetrieveSearchDataList),
          this.store.select(getBookWidgetFields),
          this.store.select(getBookWidgetFieldsMasterConfig),
          this.store.select(getCatalogApiFieldsValue),
          this.store.select(getBookWidgetAem)
        ]),
        switchMap(
          ([
            { index },
            retrieveSearchDataList,
            bookWidgetFields,
            bookWidgetFieldsMasterConfig,
            catalogApiFieldsValue,
            bookWidgetAem
          ]) => {
            const updatedBookWidgetFields = updateFieldsFromRecentSearch(
              retrieveSearchDataList,
              index,
              bookWidgetFields,
              bookWidgetFieldsMasterConfig,
              catalogApiFieldsValue,
              bookWidgetAem
            );
            return of(
              fromBookWidgetActions.UpdateFieldsFromRecentSearch({
                bookWidgetFields: updatedBookWidgetFields
              })
            );
          }
        )
      )
  );

  constructor(private actions$: Actions, private store: Store) {}
}
